import { css, cssPartial } from '@microsoft/fast-element';
import { MainStyles } from '../../../../main/main.styles';

export const SummaryTableCell = cssPartial`
display: flex;
    padding: 8px 12px;
    box-sizing: border-box;
    font-family: 'Roboto-Bold', 'Roboto Bold', 'Roboto', sans-serif;
    font-weight: 700;
    font-size: 11px;
    color: #c9c9c9;
    text-align: right;
    line-height: normal;
    align-items: center;
    flex-direction: row-reverse;
    border-left: 1px solid rgb(55, 62, 69);
    justify-content: center;
`;

export const AnalyticsStepThreeStyles = css`
  ${MainStyles}
  :host {
    display: contents;
  }

  .container {
    padding: 12px;
    height: calc(100% - 36px);
    width: 100%;
  }

  .summary-card {
    display: flex;
    padding: 2px 2px 2px 2px;
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #202227;
    box-sizing: border-box;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.35);
  }

  .summary-card-body {
    padding-top: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
    height: calc(100% - 32px);
    border-radius: 6px;
    border: 1px solid #2e3339;
    background-color: #202227;
    box-sizing: border-box;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.35);
  }

  .summary-card-header {
    height: 36px;
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 2px 2px 2px 16px;
    background-color: #22272a;
    box-sizing: border-box;
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.35);
  }

  .summary-card-header .tab-title {
    box-sizing: border-box;
    font-size: 13px;
    font-family: 'Roboto-Medium', 'Roboto Medium', 'Roboto', sans-serif;
    font-weight: 500;
    color: #f1f1f1;
    text-align: right;
    line-height: normal;
  }

  .summary-table {
    height: 100%;
    overflow: auto;
    display: grid;
    grid-template-columns: 200px repeat(auto-fit, minmax(200px, 1fr));
    grid-template-rows: repeat(auto-fill, 100%);
    grid-auto-flow: column;
  }

  .summary-table > summary-table-column:last-child::slotted(div) {
    border-right: 1px solid #373e45;
  }

  .summary-table-columns {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 76px repeat(22, 30px) 79px;
    width: 100%;
    border-left: none;
  }

  .columns-recs {
    grid-template-rows: 76px repeat(20, 30px) 79px;
  }

  .summary-table-columns > div {
    ${SummaryTableCell}
  }

  .summary-table-headers {
    position: sticky;
    left: 0;
    z-index: 1;
  }

  .summary-table-headers > div {
    color: #879ba6;
    justify-content: end;
  }

  .summary-table-headers > div:nth-child(even) {
    border-top: 1px solid #373e45;
    background-color: #2b2d32;
  }

  .summary-table-headers > div:nth-child(odd) {
    border-top: 1px solid #373e45;
    background-color: #24262b;
  }

  .summary-table-headers > div:first-child {
    border: none;
    background-color: rgb(32, 34, 39);
    position: sticky;
    left: 0;
    top: 0;
    z-index: 1;
  }

  .summary-table-headers > div:last-child {
    background-color: rgb(32, 34, 39);
    border: none;
    border-top: 1px solid #373e45;
    border-right: none;
  }

  .return-button {
    border: none;
    background: rgba(135, 155, 166, 0.15);
    border-radius: 4px;
    margin-right: 10px;
    height: 28px;
    min-width: auto;
  }

  .return-button:hover {
    background: rgba(135, 155, 166, 0.2);
  }
`;
